import { render, staticRenderFns } from "./TableDevice.vue?vue&type=template&id=5291cfd0&scoped=true&"
import script from "./TableDevice.vue?vue&type=script&lang=js&"
export * from "./TableDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5291cfd0",
  null
  
)

export default component.exports